import React from 'react'
import { withTranslation } from 'react-i18next'

import EditBlockButton from './Controls/EditBlockButton'
import MemoryPlaygroundPreview from './Modals/MemoryCardsModal/components/MemoryPlaygroundPreview/MemoryPlaygroundPreview'
import MemoryCardsModal from './Modals/MemoryCardsModal/MemoryCardsModal'

class MemoryCards extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
        }
    }

    openModal = evt => {
        evt.preventDefault()
        this.setState({
            showModal: true,
        })
    }
    closeModal = () => {
        this.setState({
            showModal: false,
        })
    }

    render() {
        const {
            struct,
            colorTheme,
            enableTimer,
            isEnableRating,
            numberedCardBacks,
            onUpdate,
            methods,
            id,
            i18n,
        } = this.props
        const { showModal } = this.state

        return (
            <div className="memory-cards-block">
                <EditBlockButton onClick={this.openModal} />
                <div className="memory-cards-block__preview">
                    <MemoryPlaygroundPreview
                        data={{
                            colorTheme,
                            cardLayout: struct.playground.cardLayout,
                            cardBackImage: struct.playground.cardBackImage,
                            cardProportions: struct.playground.cardProportions,
                            isShowCover: struct.playground.isShowCover,
                            coverHeader: struct.playground.coverHeader,
                            coverButtonText: struct.playground.coverButtonText,
                            enableTimer,
                            isEnableRating,
                            numberedCardBacks,
                        }}
                    />
                </div>

                {/* Modal */}
                {showModal ? (
                    <MemoryCardsModal
                        data={{
                            structure: struct,
                            colorTheme,
                            id,
                        }}
                        methods={{
                            openAssetManager: methods.openAssetManager,
                            closeModal: this.closeModal,
                            save: onUpdate,
                        }}
                        modalTitle={i18n.t('Memory Options')}
                    />
                ) : null}
            </div>
        )
    }
}

export default withTranslation('translations')(MemoryCards)
